import { createMemoryHistory, createRouter } from 'vue-router'




export default  createRouter({
  history: createMemoryHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
        component: () => import('./views/Home.vue')
    },
    {
      path: '/editNotification/:id',
      name: 'editNotification',
      component: () => import('./views/EditNotification')
    },
    {
        path: '/addNotification/',
        name: 'addNotification',
        component: () => import('./views/EditNotification.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});
